import { templatesRegistry } from 'utils/templates';

export function initGoogleAnalytics(templateId) {
  const template = templatesRegistry.getConfig(templateId);
  const enableGoogleAnalytics = template?.enableGoogleAnalytics;
  const gaTrackingId = template?.gaTrackingId;

  if (!enableGoogleAnalytics) {
    window.gtag = null;
    window.dataLayer = null;
    return;
  }

  if (window.gtag && window.dataLayer) {
    // Check if the same tracking ID is already initialized
    const currentTrackingId = window.dataLayer.find(
      (item) => Array.isArray(item) && item[0] === 'config' && item[1]
    )?.[1];

    if (currentTrackingId === gaTrackingId) {
      return;
    } else {
      // Clear existing gtag if different tracking ID
      window.gtag = null;
      window.dataLayer = [];
    }
  }

  // Initialize dataLayer
  window.dataLayer = window.dataLayer || [];

  // Define gtag function
  function gtag() {
    window.dataLayer.push(arguments);
  }

  window.gtag = gtag;

  // Load Google Analytics script
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${gaTrackingId}`;
  document.head.appendChild(script);

  // Initialize Google Analytics
  gtag('js', new Date());
  gtag('config', gaTrackingId);
}
